import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import StateAnalysis from "./StateAnalysis";
import { useDispatch } from "react-redux";
import { uiInfoActions } from "../../../actions";

const AnalysisPage = () => {
  const dispatch = useDispatch();
  const quarters = useSelector((state) => state.publishedQuarter.data);

  useEffect(() => {
    dispatch(uiInfoActions.publishedQuarter());
  }, []);

  if (quarters) {
    return <StateAnalysis quarters={quarters} />;
  } else {
    return <></>;
  }
};

export default AnalysisPage;
